import { render, staticRenderFns } from "./catp-protection.component.vue?vue&type=template&id=73020ba1&"
import script from "./catp-protection.component.vue?vue&type=script&lang=tsx&"
export * from "./catp-protection.component.vue?vue&type=script&lang=tsx&"
import style0 from "./catp-protection.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports